import { Theme } from "@mui/material";

export const getAppBarColor = (env: string, theme: Theme) => {
  if (!env) return theme.palette.primary.main;
  if (env.includes("pre-staging")) return "#8A2BE2";
  if (env.includes("staging")) return "#4CAF50";
  if (env.includes("qa")) return theme.palette.error.main;
  return theme.palette.primary.main;
};

export const getEnvChipColors = (env: string): { bg: string; color: string } => {
  const e = env?.toLowerCase() ?? '';
  if (e.includes('pre-staging')) return { bg: '#f0e6fa', color: '#8A2BE2' };
  if (e.includes('staging'))     return { bg: '#e6f4ea', color: '#2e7d32' };
  if (e.includes('qa'))          return { bg: '#fde8e8', color: '#c0392b' };
  return { bg: '#e3edf8', color: '#004bb1' };
};